// extracted by mini-css-extract-plugin
export var linkText = "_pl-0";